// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__DocumentsTabContent__mE7Y7{display:flex;flex-direction:column;gap:var(--tri-space-500)}`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/DocumentsTabContent/styles.module.scss"],"names":[],"mappings":"AAAA,qCACE,YAAA,CACA,qBAAA,CACA,wBAAA","sourcesContent":[".DocumentsTabContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--tri-space-500);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DocumentsTabContent": `sputnik__DocumentsTabContent__mE7Y7`
};
export default ___CSS_LOADER_EXPORT___;
